import { useState } from 'react'
import Avatar from '@mui/material/Avatar'
import ContactInfoMenuItem from './ContactInfoMenuItem'
import makeStyles from '@material-ui/core/styles/makeStyles'
import SignOut from '../../../components/1elements/Icons/svg/adminLeftMenu/signOut.svg'
import EditProfile from '../../../components/1elements/Icons/svg/adminLeftMenu/editProfile.svg'

const UserInfoCard = ({ minimizeMenu }) => {
  const classes = useStyles({ minimizeMenu })
  const [optionsMenu, setOptionsMenu] = useState(false)
  const userImage = window.localStorage.getItem('image_url')
  const userName = window.localStorage.getItem('username')
  const userEmail = window.localStorage.getItem('email')

  const getUserName = () => {
    const useNameParts = userName
      // eslint-disable-next-line no-useless-escape
      .replace(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/g, '')
      .split(' ')

    if (useNameParts.length === 0) return 'User Name'
    if (useNameParts.length === 1) return useNameParts[0]

    return `${[useNameParts[0], useNameParts[useNameParts.length - 1][0]].join(
      ' '
    )}.`
  }
  const getUserNameIniials = () => {
    var useNameParts

    if (userName)
    {
      useNameParts = userName.split(' ')
    }else {useNameParts = ['NA']}

    if (useNameParts.length === 1) return useNameParts[0][0]

    return [useNameParts[0][0], useNameParts[1][0]].join(' ')
  }
  const getUserEmail = () => {
    const emailParts = userEmail.split('')

    if (emailParts.length === 0) return ''

    return emailParts.length > 15
      ? `${emailParts.slice(0, 15).join('')}...`
      : emailParts.join('')
  }

  return (
    <div className={classes.root}>
      <div className={classes.userInfo}>
        <div className={classes.userInfoItems}>
          <Avatar src={userImage} alt="UserImage">
            {getUserNameIniials()}
          </Avatar>
          {!minimizeMenu && (
            <div className={classes.userName}>
              <div className={classes.name}>{getUserName()}</div>
              <div className={classes.email}>{getUserEmail()}</div>
            </div>
          )}
        </div>
        <div
          className={classes.options}
          onClick={() => setOptionsMenu((prev) => !prev)}
        >
          <div></div>
          <div></div>
          <div></div>
        </div>
        {optionsMenu && (
          <div
            className={classes.optionsMenu}
            onMouseOver={() => setOptionsMenu(true)}
            onMouseLeave={() => setOptionsMenu(false)}
          >
            <div className={classes.optionsMenuWrapper}>
              <ContactInfoMenuItem
                minimizeMenu={minimizeMenu}
                setOptionsMenu={setOptionsMenu}
                text="Edit Profile"
                image={EditProfile}
                linkTo={undefined}
              />
              <ContactInfoMenuItem
                minimizeMenu={minimizeMenu}
                setOptionsMenu={setOptionsMenu}
                text="Sign Out"
                image={SignOut}
                linkTo={'signOut'}
              />
              <div className={classes.optionMenuTriangle}></div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default UserInfoCard

const useStyles = makeStyles((theme, props) => ({
  root: {
    position: 'fixed',
    width: (props) => (props.minimizeMenu ? 'auto' : '235px'),
    maxWidth: (props) => (props.minimizeMenu ? '100px' : '400px'),
    zIndex: 10,
    bottom: 0,
    padding: '0 0 0 10px',
    transition: 'all 0.2s ease',
    backgroundColor: theme.palette.quaternary.accent,
    height: '85px'
  },
  userInfo: {
    width: '100%',
    height: '60px',
    backgroundColor: 'white',
    border: `1px solid ${theme.palette.secondary.main}`,
    borderRadius: '5px',
    padding: (props) => (props.minimizeMenu ? '5px' : '10px'),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: (props) =>
      props.minimizeMenu ? 'flex-start' : 'space-between',
    alignItems: 'center',
    position: 'relative'
  },
  userInfoItems: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  userName: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    marginLeft: '10px',
    opacity: (props) => (props.minimizeMenu ? 0 : 1),
    transition: 'all 0.3s ease'
  },
  name: {
    ...theme.typography.h3,
    color: theme.palette.tertiary.main
  },
  email: {
    ...theme.typography.p,
    color: theme.palette.primary.main
  },
  options: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    padding: (props) => (props.minimizeMenu ? '0 6px' : '0 10px'),
    '&>div': {
      background: `none repeat scroll 0 0 ${theme.palette.primary.main}`,
      height: '4px',
      width: '4px',
      lineHeight: 0,
      listStyle: 'none outside none',
      marginTop: '3px',
      verticalAlign: 'top',
      borderRadius: '50%',
      pointerEvents: 'none'
    },
    '&:hover': {
      cursor: 'pointer'
    }
  },
  optionsMenu: {
    position: 'absolute',
    width: '100%',
    height: '80px',
    bottom: 47,
    left: (props) => (props.minimizeMenu ? -1 : -6),
    backgroundColor: 'transparent',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  optionsMenuWrapper: {
    width: '100%',
    height: '90%',
    backgroundColor: 'white',
    borderRadius: '5px',
    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.25)',
    border: 'none',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative'
  },
  optionMenuTriangle: {
    width: 0,
    height: 0,
    borderLeft: '10px solid transparent',
    borderRight: '10px solid transparent',
    borderTop: '10px solid white',
    position: 'absolute',
    right: (props) => (props.minimizeMenu ? 1 : 5),
    bottom: -9,
    zIndex: '1'
  }
}))
